/* global apiConn */
const React = require('react');

const eventHandler = require('./eventhandler.js');

const SelectedFilters = React.createClass({
  propTypes: {
    category: React.PropTypes.string,
    filter: React.PropTypes.object
  },

  getInitialState () {
    const state = {
      category: 'Recept',
      type: null,
      author: null,
      time: null
    };

    return state;
  },

  componentDidMount () {
    eventHandler.on('filterSelectChange', this.setFilters);
  },

  componentWillUnmount: function () {
    eventHandler.removeListener('filterSelectChange', this.setFilters);
  },

  setFilters: function (item) {
    const state = {...this.state};
    const title = item.value === 'alla' ? null : item.title;

    switch(item.id) {
      case 'vad':
        state.category = title;
        break;
      case 'typ':
        state.type = title;
        break;
      case 'skribent':
        state.author = title;
        break;
      case 'tid':
        state.time = title;
        break;
    }

    this.setState(state);
  },

  clearFilters: function () {
    const { category } = this.state
    const newState = {vad: category[0].toUpperCase() + category.slice(1), typ: 'alla', skribent: 'alla', tid: 'alla'}
    eventHandler.emit('clearFilters');
    eventHandler.emit('filter', newState);
    this.setState({type: null, author: null, time: null})
  },

  render () {
    const { category, type, author, time} = this.state;
    const text = []
    if(category) {
      if(type) {
        text.push(`typen ${type}`)
      }
      if(author) {
        text.push(`skribent: ${author}`)
      }
      if(time) {
        text.push(`tid: ${time}`)
      }
    }
    return (
      <div className='filter-result-info'>
        {text.length > 0 && <span>
          Sökresultatet är filtrerat på {category} av {text.join(', ')}. - <span onClick={this.clearFilters} className='reset-filters'><span className='close-icon' />Rensa filtrering</span>
        </span>}
      </div>
    );
  }
});

module.exports = SelectedFilters;



// WEBPACK FOOTER //
// ./src/scripts/components/selectedFilters.js